import React, { useRef } from 'react';
import colors from '../../../helpers/colors';
import { useFocus, useHover } from '../../../hooks/useElementState';
import { applyComponentTheme } from '../../../theme';
import {
  Body,
  ContactInfoContainer,
  Heading,
  HeadingWrapper,
  OpeningHoursContainer,
  PhoneNumber,
  StyledIcon,
  StyledRichText,
} from './styles';

export type SplitInfoCardContentProps = {
  icon: string;
  heading: string;
  body?: string;
  phoneNumber?: string;
  phoneNumberAria?: string;
  openingHours: string;
  openPhoneInNewTab?: boolean;
};

const SplitInfoCardContent: React.FC<SplitInfoCardContentProps> = ({
  icon,
  heading,
  body,
  phoneNumber,
  phoneNumberAria,
  openingHours,
  openPhoneInNewTab,
}) => {
  const ref = useRef<HTMLAnchorElement>(null);
  const isHovering = useHover(ref);
  const isFocused = useFocus(ref);

  return (
    <>
      <ContactInfoContainer>
        <HeadingWrapper>
          <StyledIcon
            name={icon}
            size="large"
            displayVariant={!(isHovering || isFocused)}
            color={colors.core01}
          />
          <Heading>{heading}</Heading>
        </HeadingWrapper>
        {!!phoneNumber && (
          <PhoneNumber
            aria-label={phoneNumberAria}
            href={`tel:${phoneNumber}`}
            openInNewTab={openPhoneInNewTab}
            removeVisitedStyle>
            {phoneNumber}
          </PhoneNumber>
        )}
        {body && <Body html={body} />}
      </ContactInfoContainer>
      <OpeningHoursContainer>
        <StyledRichText html={openingHours} />
      </OpeningHoursContainer>
    </>
  );
};

export default applyComponentTheme(SplitInfoCardContent, 'SplitInfoCardContent');
